// API configuration utility
// Uses relative URLs on production domain, full URL on preview

const getApiBaseUrl = () => {
  // Check if we're on the production domain
  const isProduction = typeof window !== 'undefined' && 
    (window.location.hostname === 'houseplandirect.com' || 
     window.location.hostname === 'www.houseplandirect.com');
  
  if (isProduction) {
    // Use relative URL on production - this ensures API calls go to the same domain
    return '';
  }
  
  // Use the configured backend URL for preview/development
  return process.env.REACT_APP_BACKEND_URL || '';
};

export const API_BASE_URL = getApiBaseUrl();
export const API_URL = `${API_BASE_URL}/api`;

export default API_URL;
